jQuery(function () {
    var $dismiss = jQuery('.alert__dismiss');

    $dismiss.on('click', function (event) {
        event.preventDefault();

        jQuery(this).parent('.alert').animate({
            height: 0
        }, 150, function () {
            jQuery(this).remove();
        });
    });
});

var alertBypass = {
    version: '1.0',
    author: 'CAA Digital',
    project: 'AODA',
    Date: 'Dec 2020',

    //initialization 
    init: function () {
        var context = this;

        //Global variables
        context.config = {
            isAlertBlock: document.querySelector("#alert_copy"),
            mainBypassBlock: document.querySelector("a.skip-link.sr-only"),
            alertBypassBlockHtml: '<a class="skip-link sr-only" id="alert_bypass_block" href="#alert_copy">Skip to Alert Block</a>'
        };

        //Call DOM invoking functions here
        context.onDomReady();
        context.eventHandlers();
    },

    onDomReady: function () {
        var context = this,
            isAlertBlock = context.config.isAlertBlock,
            mainBypassBlock = context.config.mainBypassBlock,
            alertBypassBlockHtml = context.config.alertBypassBlockHtml;
        //Load all functions
        if (isAlertBlock) {
            mainBypassBlock.insertAdjacentHTML("beforebegin", alertBypassBlockHtml);
        }

    },

    //Handle all page level events
    eventHandlers: function () {
        //Event handlers
        var alertDismiss = document.querySelector(".alert__dismiss"),
            alertBypassBlock = document.getElementById("alert_bypass_block");
        if(alertDismiss){
        alertDismiss.addEventListener("click", function () {
            if (alertBypassBlock) {
                alertBypassBlock.remove();
            }
        })
        }
    }
};

window.addEventListener("load", function () {
    alertBypass.init();
});